import React from 'react';
import { FaCheck } from 'react-icons/fa';

function Card(props) {
  const { title, img, text, tag, highlights } = props;

  return (
    <article className="service-card card">
      {tag ? <p className="service-card-tag">{tag}</p> : null}
      <div className="service-card-image-wrap">
        <img
          alt=""
          src={process.env.PUBLIC_URL + '/img/' + img}
          className="service-card-image"
        />
      </div>
      <div className="service-card-body">
        <h3 className="card-title service-card-title">{title}</h3>
        <p className="card-text service-card-text">{text}</p>
        {Array.isArray(highlights) && highlights.length > 0 ? (
          <ul className="service-card-highlights">
            {highlights.map((item) => (
              <li key={item}>
                <FaCheck className="service-card-check" aria-hidden />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </article>
  );
}

export default Card;
